import React from 'react';
import PaginaDeVentas from './p3Fu5ZY6PfDSNt8AV8mzzx.frame';

/** The frames this prototype plays, in order, by frame id. */
export const flow = ['p3Fu5ZY6PfDSNt8AV8mzzx'];

/** The size every frame draws at, unless one exports its own. */
export const viewport = 'web';
export default function Prototype(_props: {
  start?: string;
}) {
  return <PaginaDeVentas data-id="element-18" data-mp="ewv48s4qd39h" />;
}